var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "boss-main-container" },
    [
      _c("real-intention-form", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isSubmittable,
            expression: "!isSubmittable",
          },
        ],
        attrs: {
          "is-edit": _vm.isEdit,
          "real-intention": _vm.realIntention,
          "data-test": "real-intention-form",
        },
        on: {
          "update:realIntention": function ($event) {
            _vm.realIntention = $event
          },
          "update:real-intention": function ($event) {
            _vm.realIntention = $event
          },
          filledOut: function ($event) {
            return _vm.setSubmittableAndScrollToTop(true)
          },
        },
      }),
      _vm._v(" "),
      _c("real-intention-confirm", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isSubmittable,
            expression: "isSubmittable",
          },
        ],
        attrs: {
          "is-edit": _vm.isEdit,
          "real-intention": _vm.realIntention,
          "data-test": "real-intention-confirm",
        },
        on: {
          back: function ($event) {
            return _vm.setSubmittableAndScrollToTop(false)
          },
          "un-publish": function ($event) {
            return _vm.registerOrUpdate(false)
          },
          publish: function ($event) {
            return _vm.registerOrUpdate(true)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }